import { gql } from '@apollo/client';
export const AmProtCustomizableDropDownOptionFragment = gql`
  fragment AmProtCustomizableDropDownOptionFragment on AmProtCustomizableDropDownOption {
    values {
      uid
      option_id
      value_index
      default_label
      label
      price
      sku
      swatch_data {
        type
        value
        thumbnail
      }
    }
  }
`;
export const AmProtCustomizableRadioOptionFragment = gql`
  fragment AmProtCustomizableRadioOptionFragment on AmProtCustomizableRadioOption {
    values {
      uid
      option_id
      value_index
      default_label
      label
      price
      sku
      swatch_data {
        type
        value
        thumbnail
      }
    }
  }
`;

export const ProductDetailsFragment = gql`
  fragment ProductDetailsFragment on ProductInterface {
    __typename
    rating_summary
    review_count
    categories {
      uid
      name
      url_key
      breadcrumbs {
        category_uid
      }
    }
    video_url
    ready_to_ship_product_url
    estimate_delivery {
      code
      value
    }
    special_price
    description {
      html
    }
    short_description {
      html
    }
    question_answer {
      author
      email
      question
      answer
      date
    }

    notes
    id
    uid
    sub_title_name
    is_try_on
    try_on_map_sku
    robes_gifts_customization
    order_free_swatch {
      label
      href
    }
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    media_gallery_entries {
      uid
      label
      position
      disabled
      file
    }
    media_gallery {
      label
      url(width: 90, height: 132)
      thumbnail: url(type: "thumbnail", width: 90, height: 132)
      image: url(type: "image", width: 692, height: 1016)
      position
      disabled
    }
    image_gallery {
      imgUrl
    }
    name
    price {
      regularPrice {
        amount {
          currency
          value
        }
      }
    }
    related_products {
      id
      uid
      name
      sku
      price {
        regularPrice {
          amount {
            currency
            value
          }
        }
      }
      stock_status
      url_key
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          discount {
            amount_off
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
      }
      rating_summary
      small_image {
        url(type: "thumbnail", width: 90, height: 132)
      }
    }
    price_range {
      maximum_price {
        final_price {
          currency
          value
        }
        discount {
          amount_off
        }
        regular_price {
          currency
          value
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
    }
    sku
    show_attribute {
      label
      code
      id
      value
    }
    small_image {
      url(type: "thumbnail", width: 90, height: 132)
    }
    stock_status
    product_mark
    url_key
    custom_attributes {
      selected_attribute_options {
        attribute_option {
          uid
          label
          is_default
        }
      }
      entered_attribute_value {
        value
      }
      attribute_metadata {
        uid
        code
        label
        attribute_labels {
          store_code
          label
        }
        data_type
        is_system
        entity_type
        ui_input {
          ui_input_type
          is_html_allowed
        }
        ... on ProductAttributeMetadata {
          used_in_components
        }
      }
    }
    ... on ConfigurableProduct {
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      configurable_options {
        attribute_code
        attribute_id
        uid
        label
        product_id
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        values {
          uid
          default_label
          label
          store_label
          use_default_value
          value_index
          swatch_data {
            ... on ImageSwatchData {
              thumbnail
            }
            value
          }
        }
      }
      variants {
        attributes {
          code
          value_index
        }
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        product {
          id
          uid
          # eslint-disable-next-line @graphql-eslint/require-id-when-available
          media_gallery_entries {
            uid
            disabled
            file
            label
            position
          }
          media_gallery {
            label
            url(width: 90, height: 132)
            thumbnail: url(type: "thumbnail", width: 90, height: 132)
            image: url(type: "image", width: 692, height: 1016)
            position
            disabled
          }
          sku
          stock_status
          price {
            regularPrice {
              amount {
                currency
                value
              }
            }
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              discount {
                amount_off
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
              discount {
                amount_off
              }
            }
          }
          custom_attributes {
            selected_attribute_options {
              attribute_option {
                uid
                label
                is_default
              }
            }
            entered_attribute_value {
              value
            }
            attribute_metadata {
              uid
              code
              label
              attribute_labels {
                store_code
                label
              }
              data_type
              is_system
              entity_type
              ui_input {
                ui_input_type
                is_html_allowed
              }
              ... on ProductAttributeMetadata {
                used_in_components
              }
            }
          }
        }
      }
    }
  }
`;

export const ProductListingFragment = gql`
  fragment ProductListingFragment on Cart {
    id
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    items {
      uid
      select_product_image
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      available_product {
        sku
        uid
        id
        url_key
        name
      }
      product {
        __typename
        shipping_type
        uid
        name
        sku
        url_key
        media_gallery_entries {
          uid
          label
          position
          disabled
          file
        }

        estimate_delivery {
          code
          value
        }
        is_try_on
        media_gallery {
          label
          url(width: 90, height: 132)
          thumbnail: url(type: "thumbnail", width: 90, height: 132)
          image: url(type: "image", width: 692, height: 1016)
          position
          disabled
        }
        thumbnail {
          url(type: "thumbnail", width: 90, height: 132)
        }
        small_image {
          url(type: "small")
        }
        show_attribute {
          label
          code
          id
          value
        }

        price {
          regularPrice {
            amount {
              currency
              value
            }
          }
        }
        stock_status
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_id
            uid
            label
            product_id
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
          variants {
            attributes {
              uid
              code
              value_index
            }
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            product {
              uid
              stock_status
              small_image {
                url(type: "small")
              }
              thumbnail {
                url(type: "thumbnail", width: 90, height: 132)
              }
              media_gallery_entries {
                uid
                disabled
                file
                label
                position
              }
              media_gallery {
                label
                url(width: 90, height: 132)
                thumbnail: url(type: "thumbnail", width: 90, height: 132)
                image: url(type: "image", width: 692, height: 1016)
                position
                disabled
              }
            }
          }
        }
        ampProtOption {
          items {
            uid
            label
            attribute_id
            type
            sort_order
            ...AmProtCustomizableDropDownOptionFragment
            ...AmProtCustomizableRadioOptionFragment
          }
        }
        categories {
          uid
          name
          breadcrumbs {
            category_uid
          }
        }
      }
      robes_gifts_customization {
        label
        value
      }
      prices {
        price {
          currency
          value
        }
        row_total {
          value
        }
        total_item_discount {
          value
        }
      }
      quantity
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      ... on ConfigurableCartItem {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        configurable_options {
          id
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
        }
      }
      select_options {
        option_id
        option_value_id
      }
      custom_info {
        label
        value
      }
    }
  }
  ${AmProtCustomizableRadioOptionFragment}
  ${AmProtCustomizableDropDownOptionFragment}
`;
